// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyD_VAJds-3i4VmiTBRxiHE54dcrIKMTzb4',
    authDomain: 'picket-f7d31.firebaseapp.com',
    projectId: 'picket-f7d31',
    storageBucket: 'picket-f7d31.appspot.com',
    messagingSenderId: '413541927898',
    appId: '1:413541927898:web:62a356f8546275a83ecee3',
    measurementId: 'G-YR8Y5DFB2V',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
